module.exports = __webpack_public_path__ + "img/pmGrey.7f9dcb4c.svg";